import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { BoardContext, SocketContext } from "../../../context";
import { MainButton } from "../../atoms";


const StartIntroductionOrSkip = () => {
    const { t } = useTranslation();
    const { finishIntroductionSocketEvent } = useContext(SocketContext);
    const { setInstructionTutorial, setIsCurrentlyPhase16 } = useContext(BoardContext);

    const finishInstructions = () => {
        setInstructionTutorial("x");
        finishIntroductionSocketEvent();
        setIsCurrentlyPhase16(false);
    }

    const startInstructions = () => {
        setInstructionTutorial("solutionCards");
        setIsCurrentlyPhase16(false);
    }

    return (
        <div className="start_introduction_or_skip_wrapper delay_animation center_horizontally_and_vertically" >
            <div className="start_introduction_or_skip_content" >
                <div className="start_introduction_or_skip_title"> {t("instructionsText")} </div>
                <div className="gradient_line_holder center_horizontally_and_vertically animation_ripple animation_ripple_delay_4">
                    <div className="linear_gradient_line_horizontal" style={{ width: "70%" }}></div>
                </div>
                <div className="start_introduction_or_skip_start">
                    <div> {t("letsGetToKnowTheGameText")} </div> 
                    <div className="start_introduction_or_skip_start_button">
                        <MainButton text={t("startText")} type="big" clickHandler={() => startInstructions() }  />
                    </div>
                </div>
                <div className="start_introduction_or_skip_skip">
                    <div> {t("doYouAlreadyKnowTheGameSkipToPlayText")} </div>
                    <div className="start_introduction_or_skip_skip_button">
                        <MainButton text={t("skipText")} type="big" clickHandler={() => finishInstructions()}  />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StartIntroductionOrSkip;